import { Menu } from 'iconoir-react';
import { FC } from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants/shared';
import {
  DROPDOWN_MENU_ALIGN,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@savgroup-front-common/core/atoms/DropdownMenu';
import {
  SafeFormattedMessage,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { AutocompleteOption } from '@savgroup-front-common/types';

import messages from './messages';
import {
  $ProfileMenuContainer,
  $ProfileMenuTrigger,
} from './ProfileMenu.styles';

interface ProfileMenuProps {
  acceptedLanguagesBySeller: string[];
  currentLanguage: string;
  onChangeLanguage: (
    locale: AutocompleteOption<string> | null | undefined,
  ) => unknown;
  onLogout: () => Promise<void>;
}

export const ProfileMenu: FC<ProfileMenuProps> = ({
  acceptedLanguagesBySeller,
  currentLanguage,
  onChangeLanguage,
  onLogout,
}) => {
  const currentLower = currentLanguage?.toLowerCase();
  const currentLanguageLabel =
    currentLower && currentLower in messages
      ? messages[currentLower as keyof typeof messages]
      : currentLanguage;

  return (
    <$ProfileMenuContainer>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <$ProfileMenuTrigger
            type={BUTTON_TYPES.BUTTON}
            data-testid="profileMenuTrigger"
          >
            <Menu width={24} height={24} />
          </$ProfileMenuTrigger>
        </DropdownMenuTrigger>

        <DropdownMenuContent align={DROPDOWN_MENU_ALIGN.END} sideOffset={8}>
          {acceptedLanguagesBySeller.length > 1 && (
            <>
              <DropdownMenuSub>
                <DropdownMenuSubTrigger>
                  <SafeFormattedMessageWithoutSpread
                    message={currentLanguageLabel}
                  />
                </DropdownMenuSubTrigger>

                <DropdownMenuSubContent sideOffset={4}>
                  {acceptedLanguagesBySeller.map((language) => {
                    const lower = language.toLowerCase();
                    const isCurrent =
                      currentLanguage?.toLowerCase() === language.toLowerCase();
                    const label =
                      lower in messages
                        ? messages[lower as keyof typeof messages]
                        : language;

                    return (
                      <DropdownMenuItem
                        key={language}
                        $isActive={isCurrent}
                        onSelect={() =>
                          onChangeLanguage({ value: language, label: language })
                        }
                      >
                        {SafeFormattedMessage(label)}
                      </DropdownMenuItem>
                    );
                  })}
                </DropdownMenuSubContent>
              </DropdownMenuSub>

              <DropdownMenuSeparator />
            </>
          )}

          <DropdownMenuItem onSelect={onLogout}>
            <SafeFormattedMessageWithoutSpread message={messages.logout} />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </$ProfileMenuContainer>
  );
};
